import classNames from "classnames";
import * as React from "react";
import {
  Dict,
  User,
  formatDate,
  createStartOfDayWithTimeZone,
} from "../../core";
import "../../styles/full-view-popup.scss";
import "../../styles/requirement.scss";
import "../../styles/sales-person.scss";
import "../../styles/tags.scss";
import { useDataLoader } from "react-remote-data-hooks";
import api from "../../api";
import {
  Location,
  SiteVisit,
  SiteVisitPropertyData,
  SiteVisitPropertyUpdateData,
  SiteVisitSchedulePreviewDetails,
} from "../../core/api/models/sitevisit";
import { IBigCalendarResource } from "../../core/components/calendar/big-calendar-component";
import RemoteDataMultiSelectDropDown from "../../components/dropdown/RemoteDataMultiSelectDropDown";
import { useForm, Controller } from "react-hook-form";
import TimeInput from "../../components/form-group/time-input";
import { DateInput } from "../../components/form-group";
import { UserImage } from "../../components/user-image";
import ScheduleSiteVisitPreview from "./scheduleSiteVisitPreview";
import { combineDateAndTime } from "../../utils/CombineDateAndTime";
import { areIntervalsOverlapping, isSameDay } from "date-fns";
import ErrorMessage from "../../components/text/ErrorMessage";
import BlankProPic from "../../styles/images/no-user-sm.png";
import BlankImage from "../../assets/images/color-noimage-lg.png";
import AddLandLordUserModal from "./AddLandLordUserModal";
import { AddNewLandLord } from "../AddLandLord/AddNewLandLord";
import { useAppSettings } from "../../core/hooks/useAppSettings";
import moment from "moment";
import PropertyDetailPage from "../property-details/PropertyDetailPage";
import { ScheduleSiteVisitHeader } from "./schedule-site-visit-header";
import { ScheduleSiteVisitSelectedPropertyForm } from "./schedule-site-visit-selected-property-form";

interface IPropertyDetailsPageProps {
  id: string;
  singleProperty: any;
  onClose: () => void;
  reload: () => void;
  onScheduleEditClick: (params: any, id: string) => void;
  onSiteVisitConfirm?: () => void;
}

const ScheduleSiteVisit: React.FunctionComponent<IPropertyDetailsPageProps> = (
  props
) => {
  const [accord, setAccord] = React.useState<boolean>(false);
  const [preview, setPreview] = React.useState<boolean>(false);
  const [scheduleData, setScheduleData] = React.useState<
    SiteVisitSchedulePreviewDetails[]
  >([]);
  const [validationError, setValidationError] = React.useState<string>("");
  const [
    currentSelectedPropertyDetail,
    setCurrentSelectedPropertyDetail,
  ] = React.useState<SiteVisitPropertyUpdateData>({ date: new Date() });
  const [openLandLordModal, setOpenLandLordModal] = React.useState<boolean>(
    false
  );
  const [detailModal, setDetailModal] = React.useState<{
    isOpen?: boolean;
    id?: string;
  }>({});
  const [isReload, setIsReload] = React.useState<boolean>(false);

  const appSettings = useAppSettings(api.settings);

  const setPropertyDetail = (update: {
    [key: string]: string | Date | User[];
  }) => {
    setCurrentSelectedPropertyDetail({
      ...(currentSelectedPropertyDetail || {}),
      ...update,
    });
  };
  const { data: siteVisit } = useDataLoader<SiteVisit>(() => {
    return api.sitevisit.getSiteVisit(props.id, props?.singleProperty?.propertyId);
  });
  const { control, handleSubmit, errors, watch } = useForm<Dict>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });
  const [propertyData, setPropertyData] = React.useState<{
    [key: string]: SiteVisitPropertyData;
  }>();
  const onClose = () => {
    props.onClose();
  };




  const splitAddress = (
    address: string
  ): { mainAddress: string; remainingAddress: string } => {
    let mainAddress = "";
    let remainingAddress = "";

    let seperatorIndex = address.indexOf(",");
    if (seperatorIndex === -1) {
      seperatorIndex = address.indexOf("-");
    }

    if (seperatorIndex !== -1) {
      mainAddress = address.substring(0, seperatorIndex).trim();
      remainingAddress = address.substring(seperatorIndex + 1).trim();
    } else {
      mainAddress = address.trim();
    }

    return { mainAddress, remainingAddress };
  };

  const renderLocation = (location: Location) => {
    const { mainAddress, remainingAddress } = splitAddress(
      location?.address || ""
    );
    return (
      <div>
        <div className="font-xs font-weight-semibold ">{mainAddress}</div>
        {remainingAddress && (
          <div className="font-xs text-gray-800">{remainingAddress}</div>
        )}
      </div>
    );
  };

  const renderAddLandLordHeader = () => {
    return (
      <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
        <div className="row align-items-center">
          <div className="col-auto" onClick={() => setOpenLandLordModal(false)}>
            <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
          </div>
          <div className="col-auto font-base font-weight-bold">
            Add Landlord User
          </div>
        </div>
      </div>
    );
  };

  const LandLordModal = () => {
    return (
      <div
        className="detail-poupup position-fixed top-0 w-50 h-100 overflow-auto in"
        style={{ maxWidth: "600px" }}
      >
        {renderAddLandLordHeader()}
        <AddNewLandLord
          onClose={() => setOpenLandLordModal(false)}
          onCreateUser={() => setIsReload(true)}
          propertyId={
            currentSelectedPropertyDetail?.currentSelectedPropertyId || ""
          }
          AddNewUser={AddLandLordUserModal}
        />
      </div>
    );
  };

  const onSubmit = (data: Dict) => {
    const allPropertyData: SiteVisitSchedulePreviewDetails[] = [];
    for (const propertyId of Object.keys(propertyData || {})) {
      const startDate = combineDateAndTime(
        createStartOfDayWithTimeZone(propertyData?.[propertyId]?.date!),
        propertyData?.[propertyId]?.start!
      );

      const endDate = combineDateAndTime(
        createStartOfDayWithTimeZone(propertyData?.[propertyId]?.date!),
        propertyData?.[propertyId]?.end!
      );
      const eachPropertyData = {
        propertyId,
        scheduledDate: {
          date: propertyData?.[propertyId]?.date,
          timing: {
            start: propertyData?.[propertyId]?.start || "",
            end: propertyData?.[propertyId]?.end || "",
          },
          startDate,
          endDate,
        },
        landLords: propertyData?.[propertyId]?.landlord!,
        agents: propertyData?.[propertyId]?.agents!,
      };
      allPropertyData.push(eachPropertyData);
    }
    setScheduleData(allPropertyData);
    setPreview(true);
    const finalReturnData = {
      agents: watch("agents"),
      scheduledProperties: allPropertyData,
    };
  };
  const validatePropertyData = (property: SiteVisitPropertyUpdateData) => {
    const selectedDateDetails: { startTime: Date; endTime: Date }[] = [];
    const start = combineDateAndTime(property?.date!, property?.start!);
    const end = combineDateAndTime(property?.date!, property?.end!);
    if (start >= end) {
      if (!validationError) {
        setValidationError("Start should be before the end time!");
      }
      return false;
    }
    if (!Object.keys(propertyData || {})?.length) {
      return true;
    }

    for (const propertyId of Object.keys(propertyData || {})) {
      if (propertyId !== property?.currentSelectedPropertyId) {
        const eachSlotData = {
          propertyId,
          startTime: combineDateAndTime(
            propertyData?.[propertyId]?.date!,
            propertyData?.[propertyId]?.start!
          ),
          endTime: combineDateAndTime(
            propertyData?.[propertyId]?.date!,
            propertyData?.[propertyId]?.end!
          ),
        };
        selectedDateDetails.push(eachSlotData);
      }
    }

    try {
      const isCoincidingSlot = selectedDateDetails?.find((d) => {
        return (
          isSameDay(start!, d.startTime) &&
          areIntervalsOverlapping(
            { start: d.startTime, end: d.endTime },
            {
              start,
              end,
            }
          )
        );
      });
      if (isCoincidingSlot) {
        if (!validationError) {
          setValidationError(
            "Given Slot coincides with previous selected slots!"
          );
        }

        return false;
      }
      return true;
    } catch (e) {
      if (!validationError) {
        setValidationError("Invalid Slots!");
      }
      return false;
    }
  };

  React.useEffect(() => {
    if (props.singleProperty) {
      setPropertyData({
        ...(propertyData || {}),
        [props.singleProperty?.propertyId]: {
          date: new Date(props?.singleProperty?.scheduleDetails?.scheduledDate?.date),
          start: moment(props?.singleProperty?.scheduleDetails?.scheduledDate?.startDate).local().format('hh:mm A'),
          end: moment(props?.singleProperty?.scheduleDetails?.scheduledDate?.endDate).local().format('hh:mm A'),
          landlord: props?.singleProperty?.scheduleDetails?.landlords!,
          agents: props?.singleProperty?.scheduleDetails?.agents!,
        },
      });
    }

  }, [])
  return (
    <>
      {!preview ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="">
            <>
              <div
                className="detail-poupup position-fixed top-0 w-100 h-100 overflow-auto in"
                style={{ maxWidth: "800px" }}
              >
                <ScheduleSiteVisitHeader
                  id={props.id}
                  onScheduleEditClick={props.onScheduleEditClick}
                  singleProperty={props.singleProperty}
                  currentSelectedPropertyDetail={currentSelectedPropertyDetail}
                  onClose={onClose}
                  propertyData={propertyData}
                  siteVisit={siteVisit}
                />
                <div className="container-fluid px-0 bg-white min-vh-100">
                  <div className="row no-gutters">
                    <div className="col-12 border-right min-vh-100 pb-5">
                      <div
                        className="font-normal font-weight-bold py-2 border-bottom px-4 d-flex align-items-center justify-content-between"
                        style={{ height: "48px" }}
                      >
                        Selected Date & Time, Client Participants, Pickup/Drop Location
                        <i
                          className={classNames({
                            "rotate-90deg icon-box border d-flex align-items-center justify-content-center ml-2 cursor-pointer": true,
                            "icon-chevron-left": true,
                            // "icon-chevron-right": false,
                          })}
                        />
                      </div>
                      <div className="row px-4 pt-2 mb-3">
                        <div className="col-6">
                          <div className="mb-3">
                            <label className="font-sm font-weight-semibold mb-2 text-uppercase">
                              PREFERRED DATES
                            </label>
                            {siteVisit?.preferedDates?.map((preferedDate) => {
                              return (
                                <div className="mb-2 font-normal font-weight-semibold">
                                  {formatDate(
                                    preferedDate.date!,
                                    "DD MMM YYYY"
                                  )}{" "}
                                  - {preferedDate.timing?.start} -{" "}
                                  {preferedDate.timing?.end}{" "}
                                </div>
                              );
                            })}
                          </div>
                          <div className="mb-3">
                            <label className="font-sm font-weight-semibold mb-2 pb-1 text-uppercase">
                              Client Participants
                            </label>
                            {siteVisit?.participants?.map((participant) => {
                              return (
                                <div className="mb-3 font-normal font-weight-semibold">
                                  <div className="d-flex align-items-center mr-3">
                                    <img
                                      src={
                                        participant?.profileImage || BlankProPic
                                      }
                                      alt={
                                        participant?.profileImage ||
                                        "property image"
                                      }
                                      className="img-cover rounded-circle img-responsive mr-2"
                                      width="24"
                                      height="24"
                                    />
                                    {`${participant?.firstName || ""} ${participant?.lastName || ""
                                      }`}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="mb-3">
                            <label className="font-sm font-weight-semibold mb-2 text-uppercase">
                              Pick up Location
                            </label>
                            <div className="font-xs text-gray-800">
                              {siteVisit?.pickup?.address}
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className="font-sm font-weight-semibold mb-2 text-uppercase">
                              Drop Location
                            </label>
                            <div className="font-xs text-gray-800">
                              {siteVisit?.drop?.address}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="font-normal font-weight-bold py-2 border-bottom border-top px-4 d-flex align-items-center justify-content-between"
                        style={{ height: "48px" }}
                      >
                        Selected Properties (
                        {siteVisit?.propertyIds?.length || 0})
                      </div>

                      {siteVisit?.propertyIds?.map((prop) => {
                        const isSelected =
                          currentSelectedPropertyDetail?.currentSelectedPropertyId ===
                          prop?.toString();
                        const propertyDetails = siteVisit?.propertyDetails?.find(
                          (p) => p._id === prop
                        );
                        const currentPropData = propertyData?.[prop];
                        return (
                          <div className="">
                            <div className="table-responsive">
                              <table className="w-100">
                                <tr
                                  className={`cursor-pointer ${isSelected ? "bg-gray-new" : ""
                                    }`}
                                  onClick={() => setAccord(!isSelected)}
                                >
                                  <td
                                    className={`py-2 pl-4 align-top ${!isSelected ? "border-bottom" : ""
                                      }`}
                                    style={{
                                      maxWidth: "114px",
                                      width: "114px",
                                    }}
                                  >
                                    <div className="py-1">
                                      <img
                                        src={
                                          propertyDetails?.propertyCoverImage ||
                                          BlankImage
                                        }
                                        width={83}
                                        height={63}
                                        className="img-cover rounded"
                                      />
                                    </div>
                                  </td>
                                  <td
                                    className={`py-2 ${!isSelected ? "border-bottom" : ""
                                      }`}
                                  >
                                    <div className="py-1 w-100 px-3">
                                      <div className="d-flex align-items-center">
                                        {currentPropData?.date && (
                                          <div className="font-sm mr-2">
                                            {formatDate(
                                              currentPropData?.date!,
                                              "DD MMM YYYY"
                                            )}{" "}
                                            - {currentPropData?.start} -{" "}
                                            {currentPropData?.end}{" "}
                                          </div>
                                        )}
                                        {currentPropData?.date ? (
                                          <div
                                            className="text-primary border border-primary font-xxs d-inline-flex align-items-center px-2 rounded-sm mb-1 "
                                            style={{ height: "20px" }}
                                          >
                                            Scheduled
                                          </div>
                                        ) : (
                                          <div className="">
                                            <div className="font-xxs font-weight-semibold px-2 border mb-2 py-1 rounded text-gray-800">
                                              Pending Visit Schedule
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                      <div className="font-sm text-truncate mb-1" role={'button'} onClick={() => {
                                        setDetailModal({
                                          isOpen: true,
                                          id: propertyDetails?._id,
                                        })
                                      }}>
                                        {propertyDetails?.propertyName}
                                      </div>
                                      <div className="font-sm text-truncate mb-1 text-gray-500">
                                        <i className="icon-location-filled mr-1"></i>
                                        {propertyDetails?.cityLocName}
                                      </div>
                                      <div className="font-xs line-clamp-2 d-flex align-items-center">
                                        <span className="text-muted pr-1">
                                          Area:
                                        </span>{" "}
                                        {
                                          propertyDetails?.attribute
                                            ?.builtUpArea
                                        }
                                        Sq.Ft{" "}
                                        {propertyDetails?.pricePerSqft && (
                                          <>
                                            <span className="dot-separator d-inline-block bg-gray-400 rounded mx-2"></span>{" "}
                                            ₹ {propertyDetails?.pricePerSqft}
                                            /Sq. Ft
                                          </>
                                        )}
                                      </div>
                                      <div className="font-sm  mb-1  d-flex">
                                        <span className="text-muted">
                                          Type:
                                        </span>{" "}
                                        <span className="mt-2 d-inline-block rounded pl-1"></span>
                                        {propertyDetails?.propertyTypeName ||
                                          ""}
                                        <span className="dot-separator mt-2 d-inline-block bg-gray-400 rounded mx-2"></span>
                                        <span className="text-muted mr-1">
                                          Floor Number:
                                        </span>{" "}
                                        {
                                          propertyDetails?.unitDetails?.floorName
                                        }

                                      </div>
                                      {currentPropData?.landlord?.length &&
                                        currentPropData?.landlord?.length > 0 ? (
                                        <div className="font-xs">
                                          <span className="text-muted pr-1">
                                            Landlord Users:
                                          </span>{" "}
                                          {currentPropData?.landlord?.map(
                                            (landLord) => {
                                              return (
                                                <div>
                                                  {" "}
                                                  {landLord?.contactName}
                                                  {landLord?.emails?.length &&
                                                    landLord?.emails?.length >
                                                    0 ? (
                                                    <>
                                                      <span className="dot-separator d-inline-block bg-gray-400 rounded mx-2"></span>{" "}
                                                      {landLord?.emails?.find(
                                                        (ml) => ml?.isPrimary
                                                      )?.email || ""}
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {landLord?.phones?.length &&
                                                    landLord?.phones?.length >
                                                    0 ? (
                                                    <>
                                                      <span className="dot-separator d-inline-block bg-gray-400 rounded mx-2"></span>{" "}
                                                      {landLord?.phones?.find(
                                                        (ph) => ph?.isPrimary
                                                      )?.phone || ""}
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {currentPropData?.agents?.length &&
                                        currentPropData?.agents?.length > 0 ? (
                                        <div className="font-xs">
                                          <span className="text-muted pr-1">
                                            Users :
                                          </span>{" "}
                                          {currentPropData?.agents?.map(
                                            (agent) => {
                                              return (
                                                <div>
                                                  {" "}
                                                  {agent.name}
                                                  <span className="dot-separator d-inline-block bg-gray-400 rounded mx-2"></span>{" "}
                                                  {agent.email}
                                                  <span className="dot-separator d-inline-block bg-gray-400 rounded mx-2"></span>{" "}
                                                  {agent.phone}
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </td>

                                  <td
                                    className={`py-2 text-right pr-4 ${!isSelected ? "border-bottom" : ""
                                      }`}
                                  >
                                    {(!currentSelectedPropertyDetail?.currentSelectedPropertyId ||
                                      currentSelectedPropertyDetail?.currentSelectedPropertyId !==
                                      prop) && (
                                        <button
                                          type="button"
                                          className="btn px-3 font-normal font-weight-medium py-1 rounded text-nowrap border"
                                          onClick={() => {
                                            setPropertyDetail({
                                              currentSelectedPropertyId: prop,
                                              landlord:
                                                currentPropData?.landlord || [],
                                              agents:
                                                currentPropData?.agents || [],
                                              start: currentPropData?.start || "",
                                              end: currentPropData?.end || "",
                                              date:
                                                currentPropData?.date ||
                                                new Date(),
                                            });
                                          }}
                                        >
                                          <span className="py-1 d-inline-flex align-items-center">
                                            {currentPropData?.start
                                              ? "Reschedule"
                                              : "Schedule"}
                                          </span>
                                        </button>
                                      )}
                                  </td>
                                </tr>
                                {isSelected && (
                                  <tr>
                                    <td
                                      colSpan={3}
                                      className="px-4 bg-gray-new border-bottom"
                                    >
                                      <ScheduleSiteVisitSelectedPropertyForm
                                        appSettings={appSettings}
                                        control={control}
                                        currentSelectedPropertyDetail={currentSelectedPropertyDetail}
                                        isReload={isReload}
                                        propertyData={propertyData}
                                        setCurrentSelectedPropertyDetail={setCurrentSelectedPropertyDetail}
                                        setIsReload={setIsReload}
                                        setOpenLandLordModal={setOpenLandLordModal}
                                        setPropertyData={setPropertyData}
                                        setPropertyDetail={setPropertyDetail}
                                        setValidationError={setValidationError}
                                        validatePropertyData={validatePropertyData}
                                        validationError={validationError}
                                        watch={watch} prop={prop} />

                                    </td>
                                  </tr>
                                )}
                              </table>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-backdrop fade show"></div>
            </>
          </div>
          {detailModal.isOpen && (
            <PropertyDetailPage
              onClose={() => setDetailModal({})}
              projectId={detailModal.id}></PropertyDetailPage>
          )}
        </form>
      ) : (
        <ScheduleSiteVisitPreview
          siteVisit={siteVisit}
          propertyDetails={scheduleData}
          isReschedule={!!props.singleProperty}
          renderLocation={renderLocation}
          onClickEdit={() => setPreview(false)}
          onClose={props.onClose}
          reload={props.reload}
          onSiteVisitConfirm={props.onSiteVisitConfirm}
        />
      )}
      {openLandLordModal && LandLordModal()}
    </>
  );
};

export default ScheduleSiteVisit;



